// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"109":"lego-pieces-category","228":"lego-piece-details","605":"lego-container-visualization","809":"users","980":"lego-pieces"}[chunkId] + "." + {"109":"9841bc47","228":"9841bc47","605":"a7a2622c","809":"0d4cfcb6","980":"72e6900e"}[chunkId] + ".css";
};